import { combineReducers } from "redux";
import {
  signin_user_reducer,
  signup_user_reducer,
  logout_user_reducer,
  reset_password_user_reducer,
  reset_password_confirm_user_reducer,
  set_onesignal_device_token_for_notification_reducer,
  user_meta_data_reducer,
  get_loggedin_user_meta_data_reducer,

  //calendar schedule
  schedule_interview_request_detail_reducer,
  schedule_interview_request_reducer,
  unregistered_user_schedule_interview_request_detail_reducer,
  get_scheduled_interview_detail_reducer,

  //calendar
  get_calendar_event_details_data_reducer,
  get_calendar_event_lists_data_reducer,
  get_calendar_scheduled_event_lists_data_reducer,
  get_calendar_upcoming_scheduled_event_lists_data_reducer,
  get_calendar_past_scheduled_event_lists_data_reducer,
  get_calendar_unregistered_user_scheduled_event_lists_data_reducer,
  get_calendar_event_link_data_reducer,
  get_calendar_availability_details_data_reducer,
  get_calendar_availability_lists_data_reducer,
  check_google_calendar_linked_data_reducer,
  store_google_calendar_token_data_reducer,
  get_google_calendar_event_lists_data_reducer,
  get_calendar_scheduled_event_lists_timings_data_reducer,
  get_calendar_event_availability_data_reducer,
  get_generated_hms_client_token_reducer,
  get_hms_room_details_reducer,
  create_hms_room_question_reducer,
  get_hms_room_questions_reducer,
  get_hms_room_question_rating_reducer,

  //public profile
  get_user_public_profile_data_reducer,
  get_all_public_event_links_data_reducer,
  get_all_candidate_public_assessment_kits_lists_data_reducer,
  get_all_candidate_public_assessment_kits_videos_data_reducer,
  get_shared_job_detail_reducer,
  get_mentor_public_profile_data_reducer,

  //search
  search_skill_user_reducer,
  search_job_user_reducer,
  search_assessment_kit_user_reducer,
  search_city_user_reducer,
  search_company_user_reducer,
  search_country_user_reducer,
  search_event_user_reducer,
  search_state_user_reducer,
  search_candidate_kanban_board_user_reducer,

  // company
  get_company_details_by_id_reducer,
  get_company_list_detail_reducer,
  get_all_jobs_user_reducer,
  get_job_details_user_reducer,
  update_user_timezone_reducer,
  get_company_jobs_lists_reducer,
  search_job_reducer,
  get_calendar_notification_reducer,
  get_invited_jobs_notification_reducer,
  get_job_changes_notification_reducer,
  get_invited_jobs_user_reducer,
  get_all_connected_jobs_reducer,
  search_company_reducer,
  search_candidate_reducer,
  search_mentor_reducer,
  get_questions_bank_reducer,
  get_all_skills_reducer,
  invited_assessment_kits_candidate_reducer,
} from "./common";

import {
  get_jobs_hiring_manager_reducer,
  create_job_hiring_manager_reducer,
  delete_job_hiring_manager_reducer,
  update_job_hiring_manager_reducer,
  create_company_hiring_manager_reducer,
  get_job_details_hiring_manager_reducer,
  get_kanboard_job_details_hiring_manager_reducer,
  get_kanboard_filtered_job_details_hiring_manager_reducer,
  set_job_title_hiring_manager_reducer,
  get_all_mentors_applied_hiring_manager_reducer,
  get_accept_reject_mentor_hiring_manager_reducer,
  get_applicant_hiring_progress_reducer,
  update_applicant_hiring_progress_reducer,
  get_applicant_comments_list_reducer,
  get_applicant_profile_info_reducer,
  get_company_details_hiring_manager_reduer,
  get_all_added_skills_hiring_manager_reducer,
  get_suggested_mentors_hiring_manager_reducer,
  get_suggested_candidates_hiring_manager_reducer,
  view_mentor_public_profile_hiring_manager_reducer,
  get_applicant_hms_videos_reducer,
  get_applicant_offer_terms_reducer,
  get_applicant_submitted_assessment_kits_reducer,
  get_all_applied_mentor_reducer,
  get_all_applied_candidates_reducer,
  get_bucket_list_by_mentor_data_reducer,
  create_shortlisting_candidate_by_hm_reducer,
  hm_delete_shortlisted_candidate_by_id_reducer,
  update_shortlisted_candidate_by_hm_data_reducer,
  get_shortlisted_candidates_by_hm_reducer,
} from "./hiringManager";

import {
  get_candidate_profile_data_reducer,
  get_candidate_intro_data_reducer,
  create_candidate_reducer,

  //candidate jobs
  get_applied_jobs_list_candidate_reducer,
  apply_job_candidate_reducer,
  get_applied_job_details_candidate_reducer,
  get_applied_jobs_summary_candidate_reducer,
  get_candidate_job_offer_details_reducer,

  //candidate education
  get_candidate_all_educational_data_reducer,
  get_candidate_education_by_id_data_reducer,

  //candidate profession
  get_candidate_profession_by_id_data_reducer,
  get_candidate_all_professional_data_reducer,

  //candidate skills
  get_candidate_all_skills_data_reducer,
  create_candidate_skills_data_reducer,

  //interview kit
  view_assigned_interview_kit_candidate_reducer,
  get_interview_question_details_candidate_reducer,
  get_mux_interview_video_upload_url_candidate_reducer,
  review_interview_kit_candidate_reducer,
  interview_submit_request_candidate_reducer,
  get_recently_assigned_assessment_kits_list_candidate_reducer,
  accept_assigned_assessment_kit_candidate_reducer,
  accept_assigned_assessment_kit_details_candidate_reducer,
  get_jobs_linked_with_assigned_assessment_kit_candidate_action,

  // portfolio
  get_candidate_all_portfolio_data_reducer,

  // jobs invites=====
  get_candidate_invited_jobs_reducer,
  get_candidate_suggested_jobs_reducer,
  get_candidate_pending_task_reducer,
  get_candidate_interview_invites_reducer,
  get_candidate_accepted_interviews_reducer,
} from "./candidate";

import {
  update_mentor_profile_reducer,
  get_mentor_profile_data_reducer,
  get_applied_job_details_mentor_reducer,
  get_applied_jobs_list_mentor_reducer,
  get_mentor_all_educational_data_reducer,
  get_mentor_all_professional_data_reducer,
  get_mentor_all_skills_data_reducer,
  get_mentor_education_by_id_data_reducer,
  get_mentor_profession_by_id_data_reducer,
  create_mentor_skills_data_reducer,
  get_mentor_dashboard_data_reducer,
  get_mentor_kanbanboard_data_reducer,
  get_all_interview_kit_data_reducer,
  get_all_published__interview_kit_data_reducer,
  get_interview_kit_by_id_data_reducer,
  get_assigned_interview_kit_job_reducer,
  view_mentor_profile_data_reducer,
  get_mentor_all_portfolio_data_reducer,
  get_submitted_candidates_list_interview_kit_mentor_reducer,
  assessment_kit_question_skill_rating_mentor_reducer,
  get_assigned_candidates_kanban_reducer,
  get_invited_candidates_kanban_reducer,
  get_all_bucket_list_data_reducer,
  create_bucketlist_data_reducer,
  get_bucket_list_data_by_id_reducer,
  get_bucketlist_candidate_data_reducer,

  // short listing
  create_shortlisting_candidate_reducer,
  update_shortlisted_candidate_data_reducer,
  delete_shortlisted_candidate_by_id_reducer,
  get_shortlisted_candidates_by_assignmentkit_reducer,
  get_shortlisted_candidates_by_job_id_reducer,
  get_interview_kit_remarklist_data_reducer,
  add_remark_to_interview_kit_data_reducer,
  update_remark_to_interview_kit_data_reducer,
} from "./mentor";

import {
  create_candidate_profile_recruiter_reducer,
  get_all_candidate_profile_recruiter_reducer,
} from "./recruiter";

import { get_all_watcher_jobs_reducer } from "./watcher";

import {
  create_assessment_kit_reducer,
  get_all_assessment_kits_data_reducer,
  get_assigned_candidates_to_assessment_kit_reducer,
  get_candidate_assigned_assessment_kits_data_reducer,
  get_assessment_kit_details_reducer,
  accept_assessment_kit_reducer,
  save_assessment_question_response_reducer,
  get_assessment_next_question_reducer,
  get_candidate_assessment_response_reducer,
  get_assigned_assessment_kit_details_data_reducer,
  get_candidate_assigned_assessment_details_reducer,
  get_skill_topics_data_reducer,
  get_assessment_custom_questions_data_reducer,
  get_candidates_assessment_reducer,
} from "./assessmentKits";

const rootReducer = combineReducers({
  //auth
  reset_password_confirm_user_reducer,
  reset_password_user_reducer,
  signin_user_reducer,
  signup_user_reducer,
  logout_user_reducer,
  set_onesignal_device_token_for_notification_reducer,
  user_meta_data_reducer,
  get_loggedin_user_meta_data_reducer,

  //calendar
  get_calendar_event_details_data_reducer,
  get_calendar_event_lists_data_reducer,
  get_calendar_scheduled_event_lists_data_reducer,
  get_calendar_upcoming_scheduled_event_lists_data_reducer,
  get_calendar_past_scheduled_event_lists_data_reducer,
  get_calendar_unregistered_user_scheduled_event_lists_data_reducer,
  get_calendar_event_link_data_reducer,
  get_calendar_availability_details_data_reducer,
  get_calendar_availability_lists_data_reducer,
  check_google_calendar_linked_data_reducer,
  store_google_calendar_token_data_reducer,
  get_google_calendar_event_lists_data_reducer,
  get_calendar_scheduled_event_lists_timings_data_reducer,
  get_calendar_event_availability_data_reducer,
  get_generated_hms_client_token_reducer,
  get_hms_room_details_reducer,
  create_hms_room_question_reducer,
  get_hms_room_questions_reducer,
  get_hms_room_question_rating_reducer,

  //public profile
  get_user_public_profile_data_reducer,
  get_all_public_event_links_data_reducer,
  get_all_candidate_public_assessment_kits_lists_data_reducer,
  get_all_candidate_public_assessment_kits_videos_data_reducer,

  //job
  get_shared_job_detail_reducer,
  get_mentor_public_profile_data_reducer,

  //calendar schedule
  schedule_interview_request_detail_reducer,
  schedule_interview_request_reducer,
  unregistered_user_schedule_interview_request_detail_reducer,
  get_scheduled_interview_detail_reducer,

  //search
  search_skill_user_reducer,
  search_job_user_reducer,
  search_assessment_kit_user_reducer,
  search_city_user_reducer,
  search_company_user_reducer,
  search_country_user_reducer,
  search_event_user_reducer,
  search_state_user_reducer,
  search_candidate_kanban_board_user_reducer,
  get_all_jobs_user_reducer,
  get_job_details_user_reducer,

  //hiring manager jobs
  get_jobs_hiring_manager_reducer,
  create_job_hiring_manager_reducer,
  delete_job_hiring_manager_reducer,
  update_job_hiring_manager_reducer,
  get_kanboard_job_details_hiring_manager_reducer,
  get_kanboard_filtered_job_details_hiring_manager_reducer,
  get_job_details_hiring_manager_reducer,
  set_job_title_hiring_manager_reducer,
  get_all_mentors_applied_hiring_manager_reducer,
  get_accept_reject_mentor_hiring_manager_reducer,
  get_company_details_hiring_manager_reduer,
  get_all_added_skills_hiring_manager_reducer,
  get_suggested_mentors_hiring_manager_reducer,
  get_suggested_candidates_hiring_manager_reducer,
  view_mentor_public_profile_hiring_manager_reducer,
  get_applicant_hms_videos_reducer,
  get_applicant_offer_terms_reducer,
  get_applicant_submitted_assessment_kits_reducer,
  get_all_applied_mentor_reducer,
  get_all_applied_candidates_reducer,
  get_bucket_list_by_mentor_data_reducer,

  //hiring manager company
  create_company_hiring_manager_reducer,
  get_applicant_hiring_progress_reducer,
  update_applicant_hiring_progress_reducer,
  get_applicant_profile_info_reducer,

  //candidate
  get_applicant_comments_list_reducer,
  get_candidate_profile_data_reducer,
  get_candidate_intro_data_reducer,
  create_candidate_reducer,

  //candidate jobs
  get_applied_jobs_list_candidate_reducer,
  apply_job_candidate_reducer,
  get_applied_job_details_candidate_reducer,
  get_applied_jobs_summary_candidate_reducer,
  get_candidate_job_offer_details_reducer,

  //candidate education
  get_candidate_all_educational_data_reducer,
  get_candidate_education_by_id_data_reducer,

  //candidate profession
  get_candidate_profession_by_id_data_reducer,
  get_candidate_all_professional_data_reducer,

  // candidate skills
  get_candidate_all_skills_data_reducer,
  create_candidate_skills_data_reducer,

  //interview kit candidate
  view_assigned_interview_kit_candidate_reducer,
  get_interview_question_details_candidate_reducer,
  get_mux_interview_video_upload_url_candidate_reducer,
  review_interview_kit_candidate_reducer,
  interview_submit_request_candidate_reducer,
  get_recently_assigned_assessment_kits_list_candidate_reducer,
  accept_assigned_assessment_kit_candidate_reducer,
  accept_assigned_assessment_kit_details_candidate_reducer,
  get_jobs_linked_with_assigned_assessment_kit_candidate_action,

  // candidate portfolio

  get_candidate_all_portfolio_data_reducer,

  // candiated jobs invites ========

  get_candidate_invited_jobs_reducer,
  get_candidate_suggested_jobs_reducer,
  get_candidate_pending_task_reducer,
  create_shortlisting_candidate_by_hm_reducer,
  hm_delete_shortlisted_candidate_by_id_reducer,
  update_shortlisted_candidate_by_hm_data_reducer,
  get_shortlisted_candidates_by_hm_reducer,
  get_candidate_interview_invites_reducer,
  get_candidate_accepted_interviews_reducer,

  //  mentor
  update_mentor_profile_reducer,
  get_mentor_profile_data_reducer,
  get_applied_job_details_mentor_reducer,
  get_applied_jobs_list_mentor_reducer,
  get_mentor_all_educational_data_reducer,
  get_mentor_all_professional_data_reducer,
  get_mentor_all_skills_data_reducer,
  get_mentor_education_by_id_data_reducer,
  get_mentor_profession_by_id_data_reducer,
  create_mentor_skills_data_reducer,
  get_mentor_dashboard_data_reducer,
  get_mentor_kanbanboard_data_reducer,
  get_all_interview_kit_data_reducer,
  get_all_published__interview_kit_data_reducer,
  get_interview_kit_by_id_data_reducer,
  get_assigned_interview_kit_job_reducer,
  view_mentor_profile_data_reducer,
  get_mentor_all_portfolio_data_reducer,
  get_submitted_candidates_list_interview_kit_mentor_reducer,
  assessment_kit_question_skill_rating_mentor_reducer,
  get_assigned_candidates_kanban_reducer,
  get_invited_candidates_kanban_reducer,
  get_all_bucket_list_data_reducer,
  create_bucketlist_data_reducer,
  get_bucket_list_data_by_id_reducer,
  get_bucketlist_candidate_data_reducer,
  create_shortlisting_candidate_reducer,
  update_shortlisted_candidate_data_reducer,
  delete_shortlisted_candidate_by_id_reducer,
  get_shortlisted_candidates_by_assignmentkit_reducer,
  get_shortlisted_candidates_by_job_id_reducer,
  get_interview_kit_remarklist_data_reducer,
  add_remark_to_interview_kit_data_reducer,

  // company
  get_company_details_by_id_reducer,
  get_company_list_detail_reducer,
  get_company_jobs_lists_reducer,
  search_company_reducer,
  search_candidate_reducer,
  search_mentor_reducer,

  //timezone
  update_user_timezone_reducer,

  // question bank
  get_questions_bank_reducer,
  create_candidate_profile_recruiter_reducer,
  get_all_candidate_profile_recruiter_reducer,
  search_job_reducer,

  //notifications
  get_calendar_notification_reducer,
  get_invited_jobs_notification_reducer,
  get_job_changes_notification_reducer,
  get_invited_jobs_user_reducer,
  get_all_connected_jobs_reducer,
  get_all_skills_reducer,
  invited_assessment_kits_candidate_reducer,
  update_remark_to_interview_kit_data_reducer,

  // watchers
  get_all_watcher_jobs_reducer,

  /// assessment kits
  get_assessment_kit_details_reducer,
  accept_assessment_kit_reducer,
  save_assessment_question_response_reducer,
  get_assessment_next_question_reducer,
  create_assessment_kit_reducer,
  get_all_assessment_kits_data_reducer,
  get_assigned_candidates_to_assessment_kit_reducer,
  get_candidate_assigned_assessment_kits_data_reducer,
  get_candidate_assessment_response_reducer,
  get_assigned_assessment_kit_details_data_reducer,
  get_candidate_assigned_assessment_details_reducer,
  get_skill_topics_data_reducer,
  get_assessment_custom_questions_data_reducer,
  get_candidates_assessment_reducer,
});

export default rootReducer;
